export default {
    accessurls: [
        {
            id: "175",
            name: "Dashboard",
            url: "/dashboard",
            icons: "fa fa-list-alt",
            sequence: 1,
            ismenu: true,
            parentid: 0,
            kavachurl: "dashboard",
            children: [
                {
                    id: "373",
                    name: "Inbound",
                    url: "/Inbound",
                    icons: "Inbound",
                    sequence: 1,
                    ismenu: true,
                    parentid: 175,
                    kavachurl: "inbound",
                    children: []
                },
                {
                    id: "204",
                    name: "Outbound",
                    url: "/Outbound",
                    icons: "Outbound",
                    sequence: 1,
                    ismenu: true,
                    parentid: 175,
                    kavachurl: "outbound",
                    children: []
                },
                {
                    id: "205",
                    name: "Emailr",
                    url: "/Emailr",
                    icons: "Emailr",
                    sequence: 3,
                    ismenu: false,
                    parentid: 175,
                    kavachurl: "emailr",
                    children: []
                },
                {
                    id: "206",
                    name: "Ecom Client Support",
                    url: "/EcomClientSupport",
                    icons: "EcomClientSupport",
                    sequence: 4,
                    ismenu: false,
                    parentid: 175,
                    kavachurl: "ecomclientsupport",
                    children: []
                },
                {
                    id: "207",
                    name: "RVP Client Support",
                    url: "/RVPClientSupport",
                    icons: "RVPClientSupport",
                    sequence: 5,
                    ismenu: false,
                    parentid: 175,
                    kavachurl: "rvpclientsupport",
                    children: []
                },
                {
                    id: "208",
                    name: "KYC Client Support",
                    url: "/KYCClientSupport",
                    icons: "KYCClientSupport",
                    sequence: 6,
                    ismenu: false,
                    parentid: 175,
                    kavachurl: "kycclientsupport",
                    children: []
                },
                {
                    id: "372",
                    name: "Forward Ticket Summary",
                    url: "/forwardticketsummary",
                    icons: "forwardticketsummary",
                    sequence: 7,
                    ismenu: true,
                    parentid: 175,
                    kavachurl: "forwardticketsummary",
                    children: []
                },
                {
                    id: "203",
                    name: "Reverse Ticket Summary",
                    url: "/reverseticketsummary",
                    icons: "reverseticketsummary",
                    sequence: 8,
                    ismenu: true,
                    parentid: 175,
                    kavachurl: "reverseticketsummary",
                    children: []
                }
            ]
        },
        {
            id: "174",
            name: "Track Shipment Summary",
            url: "/trackshipmentsummary",
            icons: "fa fa-building",
            sequence: 2,
            ismenu: true,
            parentid: 0,
            kavachurl: "trackshipmentsummary",
            children: [
                {
                    id: "427",
                    name: "SIP Trunk",
                    url: "/SIP Trunk",
                    icons: "SIP Trunk",
                    sequence: 1,
                    ismenu: false,
                    parentid: 174,
                    kavachurl: "siptrunk",
                    children: []
                },
                {
                    id: "428",
                    name: "GSM Gateway",
                    url: "/GSM Gateway",
                    icons: "GSM Gateway",
                    sequence: 2,
                    ismenu: false,
                    parentid: 174,
                    kavachurl: "gsmgateway",
                    children: []
                },
                {
                    id: "648",
                    name: "IVR Call Recording",
                    url: "/IVRCallRecording",
                    icons: "IVRCallRecording",
                    sequence: 3,
                    ismenu: true,
                    parentid: 174,
                    kavachurl: "ivrcallrecording",
                    children: []
                }
            ]
        },
        {
            id: "1153",
            name: "B2B Dashboard",
            url: "/b2b/dashboard",
            icons: "b2b/dashboard",
            sequence: 2,
            ismenu: true,
            parentid: 0,
            kavachurl: "b2b/dashboard",
            children: [
                {
                    id: "1158",
                    name: "Forward Ticket Summary",
                    url: "/b2b/forwardticketsummary",
                    icons: "dashboard",
                    sequence: 1,
                    ismenu: false,
                    parentid: 1153,
                    kavachurl: "b2b/forwardticketsummary",
                    children: []
                }
            ]
        },
        {
            id: "210",
            name: "Action Bulk Shipments",
            url: "/bulkshipment",
            icons: "bulkshipment",
            sequence: 3,
            ismenu: true,
            parentid: 0,
            kavachurl: "bulkshipment",
            children: []
        },
        {
            id: "1241",
            name: "Agent Master",
            url: "/agentmaster",
            icons: "agentmaster ",
            sequence: 3,
            ismenu: true,
            parentid: 0,
            kavachurl: "agentmaster",
            children: []
        },
        {
            id: "1090",
            name: "B2B Track Shipment",
            url: "/b2b/trackshipment",
            icons: "trackshipment",
            sequence: 4,
            ismenu: true,
            parentid: 0,
            kavachurl: "b2b/trackshipment",
            children: []
        },
        {
            id: "2053",
            name: "B2B Bulk Action",
            url: "/b2b/bulkshipment",
            icons: "bulkshipment",
            sequence: 4,
            ismenu: true,
            parentid: 0,
            kavachurl: "b2b/bulkshipment",
            children: []
        },
        {
            id: "331",
            name: "CSAW",
            url: "/csawshipments",
            icons: "csawshipments",
            sequence: 4,
            ismenu: true,
            parentid: 0,
            kavachurl: "csawshipments",
            children: []
        },
        {
            id: "1063",
            name: "Cargo Appointment Date",
            url: "/cargoappointment",
            icons: "cargoappointment",
            sequence: 5,
            ismenu: true,
            parentid: 0,
            kavachurl: "cargoappointment",
            children: []
        },
        {
            id: "1052",
            name: "Emailer System",
            url: "/emailr-system",
            icons: "emailr-system",
            sequence: 6,
            ismenu: true,
            parentid: 0,
            kavachurl: "emailrsystem",
            children: []
        },
        {
            id: "2146",
            name: "Hold Bucket",
            url: "/holdbucket",
            icons: "holdbucket",
            sequence: 7,
            ismenu: true,
            parentid: 0,
            kavachurl: "holdbucket",
            children: []
        },
        {
            id: "2147",
            name: "NDR",
            url: "/ndr",
            icons: "NDR",
            sequence: 9,
            ismenu: true,
            parentid: 0,
            kavachurl: "ndr",
            children: []
        },
        {
            id: "2148",
            name: "Manual Delivery",
            url: "/coddialer",
            icons: "coddialer",
            sequence: 10,
            ismenu: true,
            parentid: 0,
            kavachurl: "coddialer",
            children: []
        }
    ],
}



// WEBPACK FOOTER //
// ./src/ConstantRoute.js